import { ResourceBuilder } from '../../core/resource-builder'
import type { SaveChatter, ChattersListRequest, ChattersListResponse } from './model'
import type Chatter from './model'

type ChattersRequestsConfig = {
  list: {
    request: ChattersListRequest
    response: ChattersListResponse
  }
  get: {
    request: {
      urlParams: {
        id: number
      }
    }
    response: Chatter
  }
  update: {
    request: SaveChatter
    response: void
  }
}

export default new ResourceBuilder<ChattersRequestsConfig>('chatters')
